<template v-if="dialog">
	<v-dialog v-model="dialog" persistent max-width="1024px">
		<v-card>
			<v-card-title v-if="modalTitle">
				{{ modalTitle }}
			</v-card-title>
			<div class="grid-flex-container">
				<div class="grid-toolbar">
					<quick-filter
						:Columns="fields"
						:filter="quickFilter"
						@filterChanged="onQuickFilterChanged"
					/>
					<v-badge
						:value="advancedFilter.FiltersCount > 0"
						left
						class="d-none d-lg-flex"
						bordered
						overlap
					>
						<template v-slot:badge>
							<span style="color: white">{{
								advancedFilter.FiltersCount
							}}</span>
						</template>
						<v-btn color="primary" @click="onShowAdvancedFilter">
							<v-icon class="mr-1">mdi-magnify</v-icon>
							Advanced search
						</v-btn>
					</v-badge>
				</div>
				<div class="generic-grid-container">
					<grid-view
						v-if="gridView"
						:loadingData="loading"
						:gridData="linkFieldValues"
						:irisUserMetadata="irisUserMetadata"
						:visibleColumns="fields"
						:page="page"
						:rowsPerPage="rowsPerPage"
						:totalCount="totalCount"
						:sorting="sorting"
						:hasActions="false"
						@rowsPerPageChanged="onRowsPerPageChanged"
						@pageChanged="onPageChanged"
						@sortChanged="onSortChanged"
						@rowClick="onRowClicked"
					>
					</grid-view>
				</div>
			</div>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="close()">Cancel</v-btn>
			</v-card-actions>
		</v-card>
		<filters-dialog
			v-if="showAdvancedFilter"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="fields"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</v-dialog>
</template>
<script>
import GridView from '../gridViews/GridView.vue';
import QuickFilter from '../gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog.vue';
export default {
	components: { GridView, QuickFilter, FiltersDialog },
	props: {
		dialog: Boolean,
		gridView: Object,
		modalTitle: String,
		filter: Object,
		action: String,
		inventoryFormId: String,
	},
	data() {
		return {
			loading: false,
			rowsPerPage: 10,
			page: 1,
			sorting: [],
			quickFilter: { FieldId: null, Value: '' },
			advancedFilter: { Operator: 1, Filters: [] },
			linkFieldValues: [],
			irisUserMetadata: [],
			totalCount: 0,
			showAdvancedFilter: false,
		};
	},

	computed: {
		fields() {
			if (!this.gridView) return [];
			return this.gridView.Columns.filter((c) => c.IsVisible);
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.loading = true;
			let columns = [];
			if (this.fields.length > 0) {
				columns = this.fields.map((x) => x.Id);
			}
			let payload = {
				ViewId: this.gridView.Id,
				RowsPerPage: this.rowsPerPage,
				Page: this.page,
				Columns: columns,
				IncludeCount: true,
			};
			if (this.inventoryFormId)
				payload.InventoryFormId = this.inventoryFormId;

			if (this.sorting.length > 0) payload.Sorting = this.sorting;
			if (this.advancedFilter.Filters.length > 0 || this.filter) {
				payload.AdvancedFilter = this.getAdvancedFilter();
				this.advancedFilter.FiltersCount =
					this.advancedFilter.Filters.length;
			}
			if (this.quickFilter.Value) payload.QuickFilter = this.quickFilter;

			this.$store.dispatch(this.action, payload).then((resp) => {
				if (resp) {
					this.linkFieldValues = resp.Data;
					this.irisUserMetadata = resp.IrisUsers;
					this.totalCount = resp.Count;
				}
				this.loading = false;
			});
		},
		getAdvancedFilter() {
			let result = this.advancedFilter;
			if (this.filter) result.Filters.push(this.filter);
			return result;
		},
		close() {
			this.$emit('close');
		},
		onRowsPerPageChanged(value) {
			this.rowsPerPage = value;
			this.loadData();
		},
		onPageChanged(value) {
			this.page = value;
			this.loadData();
		},
		onSortChanged(value) {
			this.sorting = value;
			this.page = 1;
			this.loadData();
		},
		onQuickFilterChanged(value) {
			this.quickFilter = value;
			this.page = 1;
			this.loadData();
		},
		onAdvancedFilterChanged(value) {
			this.advancedFilter = value;
			this.page = 1;
			this.loadData();
			this.showAdvancedFilter = false;
		},
		onRowClicked(value) {
			this.$emit('rowClicked', value);
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
	},
};
</script>
